/**
 * 运营策略详情页（整合SKU完整生命周期管理）
 * 职责: 显示单个SKU从立项到运营的全流程信息
 */

import React from 'react';
import { Form, Card, Spin, Tabs } from 'antd';
import { RocketOutlined, LeftOutlined, SaveOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { PageHeader } from '../../components/Layout/PageHeader';
import { useOperationStrategyDetail } from './hooks';
import { getDetailTabItems } from './components/DetailTabsConfig';
import './OperationStrategy.css';

export const OperationStrategyDetail: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const [form] = Form.useForm();

    const {
        loading,
        skuData,
        brands,
        activeTab,
        setActiveTab,
        handleSave,
        handleCopywritingDataChange,
    } = useOperationStrategyDetail({ skuId: id, form });

    const tabItems = getDetailTabItems(skuData, form, brands, handleCopywritingDataChange);

    if (loading && !skuData) {
        return (
            <div className="operation-strategy-page">
                <div style={{ textAlign: 'center', padding: '100px 0' }}>
                    <Spin size="large" />
                    <div style={{ marginTop: 16, color: '#999' }}>加载SKU数据...</div>
                </div>
            </div>
        );
    }

    return (
        <div className="operation-strategy-page">
            <PageHeader
                title={skuData?.name || 'SKU详情'}
                subtitle={skuData?.asin ? `ASIN: ${skuData.asin}` : '产品全生命周期管理'}
                icon={<RocketOutlined />}
                breadcrumbs={[
                    { title: '首页', href: '/' },
                    { title: '运营策略', href: '/operation-strategy' },
                    { title: skuData?.name || 'SKU详情' },
                ]}
                actions={[
                    {
                        key: 'save',
                        label: '保存',
                        type: 'primary',
                        icon: <SaveOutlined />,
                        onClick: handleSave,
                    },
                    {
                        key: 'back',
                        label: '返回列表',
                        icon: <LeftOutlined />,
                        onClick: () => navigate('/operation-strategy'),
                    },
                ]}
            />

            <div className="operation-strategy-content">
                <Card variant="borderless" styles={{ body: { padding: 0 } }}>
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={tabItems}
                        tabPosition="left"
                        style={{ minHeight: 600 }}
                        tabBarStyle={{ width: 120 }}
                    />
                </Card>
            </div>
        </div>
    );
};

export default OperationStrategyDetail;
